export const ListQueryKey = 'projectProductOrders';
export const DetailQueryKey = 'projectProductOrder';
export const Urls = {
  selectUrl: '/commodity/order/list',
  updateUrl: '/commodity/order/update',
  deleteUrl: '/commodity/order/delete',
  createUrl: '/commodity/order/create',
  detailUrl: '/commodity/order/info'
};